import React, { useEffect } from "react";
import { FiArrowRight, FiZap, FiDollarSign, FiSmartphone, FiLock, FiPhoneCall, FiCheckCircle } from "react-icons/fi";
import "./Moneybro.css";

function Moneybro() {
  // Prevent navigation away from this page
  useEffect(() => {
    // Disable back button
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = function () {
      window.history.pushState(null, "", window.location.href);
    };

    // Cleanup function
    return () => {
      window.onpopstate = null;
    };
  }, []);

  const handleApplyNow = () => {
    window.open("https://web.moneybro.in/onboard/?referral_code=grydfi_02#/login/borrower", "_blank");
  };

  return (
    <div className="moneybro-container">
      <div className="moneybro-hero">
        <h1>Get Your Loan Approved Instantly</h1>
        <p>Fast, Secure & Hassle-Free Loan Application Process</p>
        <button onClick={handleApplyNow} className="moneybro-apply-btn">
          Apply Now on Moneybro <FiArrowRight />
        </button>
      </div>

      <div className="moneybro-features">
        <h2>Why Apply Through Moneybro?</h2>
        <div className="moneybro-grid">
          <div className="moneybro-card">
            <div className="moneybro-icon"><FiZap /></div>
            <h3>Quick Approval</h3>
            <p>Get loan approval within 24 hours with minimal documentation</p>
          </div>

          <div className="moneybro-card">
            <div className="moneybro-icon"><FiDollarSign /></div>
            <h3>Low Interest Rates</h3>
            <p>Competitive interest rates starting from just 8.5% per annum</p>
          </div>

          <div className="moneybro-card">
            <div className="moneybro-icon"><FiSmartphone /></div>
            <h3>100% Digital Process</h3>
            <p>Complete your application online without any physical paperwork</p>
          </div>

          <div className="moneybro-card">
            <div className="moneybro-icon"><FiLock /></div>
            <h3>Secure & Safe</h3>
            <p>Your data is encrypted and protected with bank-grade security</p>
          </div>

          <div className="moneybro-card">
            <div className="moneybro-icon"><FiPhoneCall /></div>
            <h3>24/7 Support</h3>
            <p>Dedicated customer support to assist you at every step</p>
          </div>

          <div className="moneybro-card">
            <div className="moneybro-icon"><FiCheckCircle /></div>
            <h3>No Hidden Charges</h3>
            <p>Transparent process with zero hidden fees or charges</p>
          </div>
        </div>
      </div>

      <div className="moneybro-cta">
        <h2>Ready to Get Started?</h2>
        <p>Join thousands of satisfied customers who got their loans approved with Moneybro</p>
        <button onClick={handleApplyNow} className="moneybro-cta-btn">
          Apply Now
        </button>
        <p className="moneybro-note">
          *By clicking Apply Now, you'll be redirected to Moneybro's secure application portal
        </p>
      </div>

      {/* Customer Care Section */}
      <div className="customer-care-card">
        <h3>Customer Care Support</h3>
        <p>Need help with your loan application?</p>
        <a href="tel:+919606947280" className="customer-care-btn">
          <FiPhoneCall /> Call: +91 9606947280
        </a>
      </div>
    </div>
  );
}

export default Moneybro;